export default {
  accountMenu: {
    changeEnvironment: 'Van omgeving wisselen',
    account: 'Account',
    signIn: 'Aanmelden',
    signOut: 'Afmelden',
    getSupport: 'Ondersteuning',
    settings: 'Instellingen',
    language: 'Taal',
    profile: 'Mijn profiel'
  },
  common: {
    search: 'Zoeken',
    close: 'Sluiten',
    loading: 'Laden',
    save: 'Opslaan',
    cancel: 'Annuleren',
    edit: 'Bewerken',
    delete: 'Verwijderen',
    add: 'Toevoegen',
    yes: 'Ja',
    no: 'Nee',
    ok: 'Ok',
    confirm: 'Bevestigen',
    back: 'Terug',
    next: 'Volgende',
    finish: 'Voltooien',
    apply: 'Toepassen',
    reset: 'Opnieuw instellen',
    refresh: 'Vernieuwen',
    retry: 'Opnieuw proberen',
    settings: 'Instellingen',
    submit: 'Indienen',
    more: 'Meer',
    moreActions: 'Meer acties',
    collapsedCrumbs: 'Alle broodkruimels weergeven',
    editTitle: 'Titel bewerken',
    showMore: '+ {n} meer',
    showLess: '- minder weergeven',
    select: 'Selecteren',
    multiplePaths: '{n} paden',
    alternatePaths: 'Alternatieve paden',
    copy: 'Kopiëren',
    copyTo: 'Kopiëren naar',
    duplicate: 'Dupliceren',
    moveLeft: 'Naar links verplaatsen',
    moveRight: 'Naar rechts verplaatsen',
    scanQRCode: 'QR-code scannen',
    sendRequest: 'Aanvraag versturen',
    discard: 'Negeren',
    unsavedChangesTitle: 'Niet-opgeslagen wijzigingen negeren?',
    unsavedChangesMessage:
      'U heeft niet-opgeslagen wijzigingen die verloren gaan als u deze pagina verlaat.'
  },
  admin: {
    settings: 'Instellingen',
    dataImport: {
      preserveIds: 'ID’s behouden',
      preserveIdsDetails:
        'Behoud de twin- en relatie-ID’s uit het importbestand. Bestaande twins met overeenkomende ID’s worden bijgewerkt.'
    },
    catalog: {
      title: 'Datacatalogus'
    },
    dataSources: {
      title: 'Gegevensbronnen',
      add: 'Gegevensbron toevoegen',
      empty: 'Er zijn geen gegevensbronnen aan deze omgeving toegevoegd.'
    },
    environment: {
      tabs: {
        general: 'Algemeen',
        deployment: 'Implementatie',
        apiKeys: 'API-sleutels',
        secrets: 'Geheimen',
        certificates: 'Certificaten',
        jobs: 'Taken',
        configuration: 'Configuratie'
      },
      backupRestore: {
        title: 'Back-up herstellen',
        description:
          'Selecteer een omgeving of upload een back-upbestand (.ndjson). De back-up wordt geïmporteerd in de huidige omgeving.',
        sourceCurrentEnv: 'Deze omgeving',
        sourceOtherEnv: 'Een andere omgeving',
        sourceFile: 'Vanuit back-upbestand',
        environmentLabel: 'Omgeving',
        versionTimestamp: 'Datum',
        versionSize: 'Grootte',
        versionCurrent: 'Huidig',
        restoreAction: 'Herstellen',
        downloadAction: 'Downloaden',
        noVersions: 'Geen back-upversies beschikbaar',
        selectVersionHint: 'Selecteer een versie om te herstellen',
        fileDropLabel: 'Klik of sleep back-upbestand hierheen',
        fileDropHint: 'Geaccepteerd formaat: .ndjson',
        selectedFileLabel: 'Geselecteerd bestand:',
        backupFileLabel: 'Back-upbestand:',
        outputFileLabel: 'Uitvoerbestand:',
        startRestore: 'Herstel starten',
        invalidFileType: 'Selecteer een geldig .ndjson back-upbestand.',
        uploadFailed: 'Uploaden van back-upbestand is mislukt.',
        uploadSuccess: 'Back-upbestand geüpload',
        copyUri: 'URI kopiëren',
        uriCopied: 'Back-up-URI gekopieerd naar klembord.',
        uriCopyFailed: 'Kopiëren van back-up-URI mislukt.',
        triggerBackup: 'Back-up starten',
        triggerHint: 'Handmatig een back-up van deze omgeving starten.',
        backupTriggered: 'Back-up succesvol gestart.'
      },
      apiKeys: {
        title: 'API-sleutels',
        newApiKey: 'Nieuwe API-sleutel',
        update: 'Bijwerken',
        regenerate: 'Opnieuw genereren',
        share: 'Delen',
        columns: {
          nameId: 'Naam (Id)',
          secret: 'Geheim',
          roles: 'Rollen'
        },
        notify: {
          created: 'API-sleutel succesvol aangemaakt',
          updated: 'API-sleutel succesvol bijgewerkt',
          shared: 'API-sleutel succesvol gedeeld'
        },
        dialog: {
          regenerateTitle: 'API-sleutel opnieuw genereren',
          regenerateConfirm: 'Weet u zeker dat u deze API-sleutel opnieuw wilt genereren?',
          deleteTitle: 'API-sleutel verwijderen',
          deleteConfirm: 'Weet u zeker dat u deze API-sleutel wilt verwijderen?'
        }
      },
      secrets: {
        title: 'Geheimen',
        newSecret: 'Nieuw geheim',
        share: 'Delen',
        columns: {
          nameId: 'Naam (Id)',
          secretType: 'Type',
          secret: 'Geheim'
        },
        notify: {
          created: 'Geheim succesvol aangemaakt',
          shared: 'Geheim succesvol gedeeld'
        },
        dialog: {
          deleteTitle: 'Geheim verwijderen',
          deleteConfirm: 'Weet u zeker dat u dit geheim wilt verwijderen?'
        }
      },
      certificates: {
        title: 'Certificaten',
        newCertificate: 'Nieuw certificaat',
        downloadPem: 'Downloaden (PEM)',
        downloadPfx: 'Downloaden (PFX)',
        update: 'Bijwerken',
        regenerate: 'Opnieuw genereren',
        columns: {
          nameId: 'Naam (Id)',
          expiry: 'Vervaldatum',
          thumbprint: 'Vingerafdruk'
        },
        notify: {
          created: 'Certificaat succesvol aangemaakt',
          updated: 'Certificaat succesvol bijgewerkt'
        },
        dialog: {
          regenerateTitle: 'Certificaat opnieuw genereren',
          regenerateConfirm:
            'Weet u zeker dat u dit zelfondertekend certificaat opnieuw wilt genereren?',
          deleteTitle: 'Certificaat verwijderen',
          deleteConfirm: 'Weet u zeker dat u dit zelfondertekend certificaat wilt verwijderen?'
        }
      },
      jobs: {
        downloadInput: 'Invoer downloaden',
        downloadOutput: 'Uitvoer downloaden',
        downloadFailed: 'Bestand downloaden mislukt'
      }
    },
    devices: {
      onboarding: {
        eventGridInstance: 'Event Grid-instantie',
        eventGridHint:
          'Selecteer de Event Grid MQTT-broker voor dit apparaat (standaard de implementatiebroker)',
        eventGridDefault: 'Standaard (automatisch)',
        eventGridInvalid: 'Selecteer een geldige Event Grid-instantie'
      }
    },
    models: {
      title: 'Datamodellen',
      loadFromRepo: 'Laden uit repository',
      upload: 'Uploaden',
      new: 'Nieuw',
      newModel: 'Nieuw model',
      extend: 'Uitbreiden',
      deleteAll: 'Alles verwijderen',
      export: 'Exporteren',
      filter: 'Filteren',
      view: 'Bekijken',
      decommission: 'Buiten gebruik stellen',
      selectModelHint: 'Selecteer een model om de definitie te bekijken',
      addModels: 'Modellen toevoegen',
      addSuccess: '{count} model(len) toegevoegd',
      errors: {
        empty: 'Plak een of meer DTDL-modellen voordat u opslaat.',
        invalidJson: 'De inhoud is geen geldige JSON.',
        addFailed: 'De modellen konden niet worden toegevoegd.',
        refreshFailed: 'De modellen zijn toegevoegd, maar de lijst kon niet worden vernieuwd.'
      },
      dialog: {
        decommissionTitle: 'Geselecteerd model buiten gebruik stellen',
        decommissionSingleConfirm:
          'Weet u zeker dat u dit model buiten gebruik wilt stellen? {models}',
        decommissionMultipleConfirm:
          'Weet u zeker dat u al deze modellen buiten gebruik wilt stellen? {models}',
        deleteSingleTitle: 'Geselecteerd model verwijderen',
        deleteMultipleTitle: 'Alle geselecteerde modellen verwijderen',
        deleteSingleConfirm:
          'Weet u zeker dat u het geselecteerde model en de afhankelijkheden wilt verwijderen? {models}',
        deleteMultipleConfirm:
          'Weet u zeker dat u alle geselecteerde modellen en hun afhankelijkheden wilt verwijderen? {models}',
        deleteAllTitle: 'Alle modellen verwijderen',
        deleteAllConfirm: 'Weet u zeker dat u alle modellen wilt verwijderen?'
      }
    },
    users: {
      newUsers: 'Nieuwe gebruikers',
      exportRoles: 'Rollen exporteren',
      importRoles: 'Rollen importeren',
      filter: 'Filteren',
      addRole: 'Rol toevoegen',
      deleteRole: 'Rol verwijderen',
      setKqlRole: 'KQL-databaserol instellen',
      deleteKqlRole: 'KQL-databaserol verwijderen',
      columns: {
        nameId: 'Naam (Id)',
        email: 'E-mail',
        status: 'Status',
        roles: 'Rollen'
      },
      tabs: {
        all: 'Alle gebruikers',
        registered: 'Geregistreerd',
        pending: 'In behandeling'
      },
      status: {
        registered: 'Geregistreerd',
        pending: 'In behandeling'
      },
      dialog: {
        deleteRoleTitle: 'Rol verwijderen',
        deleteRoleMessage: 'Weet u zeker dat u de rol "{role}" van {user} wilt verwijderen?',
        deleteAdxRoleTitle: 'ADX-rol verwijderen',
        deleteAdxRoleMessage:
          'Weet u zeker dat u deze ADX-gebruikersroltoewijzing wilt verwijderen?'
      },
      notify: {
        roleAdded: 'Rol {role} toegevoegd aan gebruiker {user}',
        roleAddFailed: 'Kon rol {role} niet toevoegen aan gebruiker {user}',
        roleDeleted: 'Rol {role} verwijderd van gebruiker {user}',
        roleDeleteFailed: 'Kon rol {role} niet verwijderen van gebruiker {user}',
        adxRoleAssigned: 'Rol {role} toegewezen aan gebruiker {user} in KQL-database',
        adxRoleAssignFailed: 'Kon rol {role} niet toewijzen aan gebruiker {user} in KQL-database',
        adxRoleDeleted: 'Rol {role} verwijderd van gebruiker {user} in KQL-database',
        adxRoleDeleteFailed: 'Kon rol {role} niet verwijderen van gebruiker {user} in KQL-database',
        addUsersFailed: 'Kon {count} gebruikersrollen niet toevoegen',
        addUsersSuccess: '{count} gebruikersrollen toegevoegd',
        adxRolesFailed: 'Kon ADX-rollen voor gebruikers niet ophalen'
      }
    },
    features: {
      filter: 'Filteren',
      editFeature: 'Functie bewerken',
      reorderFeatures: 'Functies herschikken',
      doneReordering: 'Klaar',
      reorderHint: 'Sleep om te herschikken',
      orderNumber: 'Volgorde {order}',
      reorderClearFilter: 'Wis het filter om functies te herschikken',
      reorderFailed: 'De nieuwe volgorde van de functies kon niet worden opgeslagen'
    },
    files: {
      upload: 'Bestand uploaden',
      download: 'Bestand downloaden',
      preview: 'Bestand bekijken',
      noConfigurationProperties: 'Geen configuratie-eigenschappen gevonden voor dit omgevingstype.'
    }
  },
  relations: {
    editRelationship: 'Relatie bewerken',
    deleteRelationship: 'Relatie verwijderen',
    deleteRelationshipConfirm: 'Weet u zeker dat u deze relatie wilt verwijderen?'
  },
  files: {
    upload: 'Uploaden',
    linkAutodeskFile: 'Autodesk-bestand koppelen',
    files: 'Bestanden',
    contextMenu: {
      viewFile: 'Bestand bekijken',
      viewOnAcc: 'Bestand bekijken op ACC',
      downloadFile: 'Bestand downloaden',
      fileVersions: 'Bestandsversies',
      uploadNewVersion: 'Nieuwe versie uploaden',
      versionItem: 'v{version}: {date} door {name}'
    },
    uploadDialog: {
      titleImages: 'Afbeeldingen uploaden',
      titleFiles: 'Bestanden uploaden',
      pickImages: 'Afbeeldingen kiezen',
      pickFiles: 'Bestanden kiezen',
      submit: 'Uploaden'
    },
    uploadVersionDialog: {
      title: 'Nieuwe versie uploaden',
      pickFile: 'Bestand kiezen',
      submit: 'Uploaden'
    },
    linkDialog: {
      title: 'Autodesk-bestand koppelen',
      submit: 'Koppelen'
    },
    linkOneLakeFile: 'OneLake-bestand koppelen',
    linkOneLakeFileDialog: {
      title: 'OneLake-bestand koppelen',
      submit: 'Koppelen'
    }
  },
  flows: {
    shared: 'Gedeeld',
    nonDurable: 'Niet duurzaam',
    disabled: 'Uitgeschakeld',
    duplicate: 'Dupliceren',
    export: 'Exporteren',
    import: 'Importeren',
    enable: 'Inschakelen',
    disable: 'Uitschakelen',
    share: 'Delen',
    columns: {
      name: 'Naam',
      lastRun: 'Laatste uitvoering',
      status: 'Status'
    },
    dialog: {
      deleteTitle: 'Flow verwijderen',
      deleteConfirm: 'Weet u zeker dat u {name} wilt verwijderen?',
      deleteSelectedTitle: 'Geselecteerde flows verwijderen',
      deleteSelectedConfirm: 'Weet u zeker dat u {count} flow(s) wilt verwijderen?',
      enableTitle: 'Geselecteerde flows inschakelen',
      enableConfirm: 'Weet u zeker dat u al deze flows ({count}) wilt inschakelen?',
      disableTitle: 'Geselecteerde flows uitschakelen',
      disableConfirm: 'Weet u zeker dat u al deze flows ({count}) wilt uitschakelen?'
    },
    importDialog: {
      title: 'Flows importeren',
      fileLabel: 'Flow-bestand(en)',
      overwrite: 'Bestaande flows overschrijven?',
      invalidFile: 'Ongeldig bestand'
    },
    copilot: {
      tabLabel: 'Copiloot',
      welcomeTitle: 'Flow Configuratie Copiloot',
      welcomeSubtitle:
        'Ik kan u helpen bij het configureren en oplossen van problemen met deze flow'
    },
    clear: 'Wissen',
    run: 'Uitvoeren',
    runWithPayload: 'Uitvoeren met payload',
    nothingSelected: 'Niets geselecteerd',
    activitiesSelected: '{count} activiteit geselecteerd | {count} activiteiten geselecteerd',
    relationshipsSelected: '{count} relatie geselecteerd | {count} relaties geselecteerd',
    layoutGraph: 'Grafiek indelen',
    topToBottom: 'Boven naar beneden',
    leftToRight: 'Links naar rechts',
    relayout: 'Herindelen',
    nonDurableExecution: 'Niet-duurzame uitvoering',
    nonDurableTooltip:
      'Niet-duurzame uitvoering is sneller voor kleine payloads, maar minder veerkrachtig. Alleen aanbevolen voor kortlopende flows.',
    disabledTooltip: 'De flow uitschakelen (voorkomt nieuwe uitvoeringen)',
    enableTooltip: 'Flow is uitgeschakeld. Klik om in te schakelen.',
    newFlow: 'Nieuwe flow',
    flowsLabel: 'Flows',
    tabs: {
      payloads: 'Payloads',
      activity: 'Activiteit',
      logs: 'Logboeken',
      runs: 'Uitvoeringen'
    },
    notify: {
      saved: 'Flow opgeslagen',
      imported: '{count} flow(s) geïmporteerd',
      shared: 'Flow succesvol gedeeld',
      flowCreated: 'Flow aangemaakt',
      activityTriggered: 'Activiteit geactiveerd',
      copiedToClipboard: 'Gekopieerd naar klembord',
      cutToClipboard: 'Geknipt naar klembord',
      invalidDataFormat: 'Ongeldig gegevensformaat'
    }
  },
  languages: {
    en: 'Engels',
    fr: 'Frans',
    nl: 'Nederlands'
  },
  history: {
    updatedBy: 'Bijgewerkt door {user}'
  },
  viewer: {
    catalogBrowser: {
      title: 'Datacatalogus',
      open: 'Datacatalogus bekijken',
      sources: {
        title: 'Catalogusbronnen',
        empty: 'Er zijn geen catalogusbronnen beschikbaar.',
        smartAtlas: 'Smart Atlas',
        oneLake: 'OneLake',
        autodesk: 'Autodesk Construction Cloud'
      },
      collections: {
        title: 'Collecties',
        empty: 'Niets komt overeen met uw zoekopdracht, of deze bron heeft geen collecties.',
        error: 'Collecties konden niet worden geladen.'
      },
      items: {
        title: 'Items',
        empty: 'Niets komt overeen met uw zoekopdracht, of deze collectie heeft geen items.',
        error: 'Items konden niet worden geladen.'
      },
      tree: {
        searching: 'Zoeken in de boom…',
        searchLimited:
          'Het zoeken dekte maar een deel van de boom. Vouw een map uit om erin te zoeken.'
      },
      preview: {
        alt: 'Voorbeeld van {name}'
      },
      item: {
        modelUnavailable: 'Niet beschikbaar in deze omgeving',
        source: 'Bron',
        selectableVariants: 'Varianten selecteren'
      }
    },
    modelVersion: {
      title: 'Modelversie',
      version: 'Versie',
      latestHint: 'Leeg laten om de laatste versie te laden telkens het model wordt geopend.',
      viewable: 'Viewable',
      loadError: 'De modelversies konden niet worden geladen uit Autodesk Construction Cloud.',
      currentVersionMissing:
        'De versie die dit model gebruikt bestaat niet meer in Autodesk Construction Cloud. Kies een versie om verder te gaan.',
      saveError: 'De modelversie kon niet worden opgeslagen.'
    },
    catalogLink: {
      configuration: {
        title: 'Laagconfiguratie',
        modelTitle: 'Modelconfiguratie',
        back: 'Terug naar de catalogus',
        variable: 'Variabele',
        dimensionSelector: 'Dimensieselector',
        layerCount: 'Voegt {count} laag toe | Voegt {count} lagen toe',
        variantDimensionRequired: 'Kies ten minste één optie voor {dimension}.',
        variantLimit: 'Selecteer maximaal {count} laagcombinaties tegelijk.',
        variableRequired: 'Selecteer een variabele voordat u deze laag toevoegt.',
        customizeStyling: 'Stijl aanpassen',
        partialCompletion:
          '{count} laag toegevoegd voor de fout. Probeer opnieuw voor de resterende lagen.'
      },
      submit: 'Laag toevoegen | {count} lagen toevoegen',
      submitModel: 'Model toevoegen'
    },
    label: {
      model: 'Model',
      map: 'Kaart'
    },
    menu: 'Menu',
    openModelOf: 'Open model van',
    openPanel: 'Lagen',
    mapActionsLabel: 'Kaartacties',
    scrollZoomInteractionTooltip:
      'Normaal scrollzoomen in- of uitschakelen. Houd Ctrl (Cmd op Mac) ingedrukt tijdens het scrollen om te zoomen wanneer het uit staat.',
    sourceOptions: {
      autodesk: {
        label: 'Autodesk Construction Cloud koppelen',
        description:
          'Koppel een bestaand 3D- of 2D-model dat wordt gehost op Autodesk Construction Cloud.'
      },
      spatialData: {
        label: 'Ruimtelijke gegevens uploaden',
        description: 'Ruimtelijke gegevens uploaden (GeoJSON, KML, KMZ, ...).'
      },
      tileLayer: {
        label: 'Tegellaag koppelen',
        description:
          'Koppel een gerasterde afbeeldingstegellaag via een TileJSON-bron of geparameteriseerde URL.'
      },
      vectorLayer: {
        label: 'Vectorlaag koppelen',
        description: "Koppel een vectortegellaag via een TileJSON-bron of geparameteriseerde URL's."
      },
      esriFeatureServer: {
        label: 'ESRI Feature Server koppelen',
        description: 'Koppel een gehoste ESRI Feature Server.'
      },
      smartAtlasProject: {
        label: 'Smart Atlas-project koppelen',
        description: 'Koppel een Arcadis Smart Atlas-project.'
      },
      geoTiff: {
        label: 'GeoTIFF uploaden',
        description: 'Upload een Cloud Optimized GeoTIFF voor dynamische tegels.'
      },
      oneLakeGeoTiff: {
        label: 'OneLake GeoTIFF koppelen',
        description:
          'Koppel een Cloud Optimized GeoTIFF opgeslagen in OneLake voor dynamische tegels.'
      },
      oneLakeSpatialData: {
        label: 'OneLake ruimtelijke data koppelen',
        description: 'Koppel ruimtelijke data (GeoJSON, KML, KMZ, ...) opgeslagen in OneLake.'
      },
      stac: {
        label: 'STAC-laag koppelen',
        description: 'Koppel een SpatioTemporal Asset Catalog (STAC)-item voor dynamische tegels.'
      },
      multidim: {
        label: 'Multidimensionale laag koppelen',
        description:
          'Koppel een multidimensionale dataset (NetCDF, GRIB, Zarr, Kerchunk) voor dynamische tegels.'
      },
      multidimUpload: {
        label: 'Multidimensionaal bestand uploaden',
        description: 'Upload een NetCDF (.nc)-bestand voor multidimensionale dynamische tegels.'
      }
    },
    stac: {
      stacUrlLabel: 'STAC-URL',
      stacUrlHint: 'URL van het STAC-item of de collectie.',
      variableLabel: 'Variabele (assetsleutel)',
      variableHint: 'Optionele assetsleutel in het STAC-item om weer te geven.',
      variableDetecting: 'Assets detecteren…',
      variableManualHint: 'Automatische detectie mislukt. Voer de sleutel handmatig in.',
      stacAssetsLabel: 'Assetsleutels (komma-gescheiden)',
      stacAssetsHint: 'Optionele komma-gescheiden lijst van assetsleutels.',
      stacAssetsDetecting: 'Assets detecteren…',
      stacAssetsManualHint: 'Automatische detectie mislukt. Voer sleutels handmatig in.',
      dimensionSelectorLabel: 'Dimensiekiezer',
      dimensionKeyLabel: 'Dimensie',
      dimensionValueLabel: 'Waarde',
      addDimension: 'Dimensie toevoegen',
      styleLabel: 'Stijl',
      opacityLabel: 'Dekking',
      rescaleLabel: 'Herschalen (min,max)',
      rescalePlaceholder: 'bijv. 0,1000',
      rescaleHint: "Optioneel min,max-bereik gescheiden door komma's voor weergaveschaling.",
      colorMapLabel: 'Kleurenschema',
      colorMapHint: 'Optioneel rio-tiler kleurenschema. Leeg laten om RGB-banden te gebruiken.'
    },
    multidim: {
      sourceUrlLabel: 'Bron-URL',
      sourceUrlHint: 'URL van de multidimensionale dataset.',
      sourceFormatLabel: 'Bronformaat',
      sourceFormatHint: 'Formaat van de multidimensionale dataset.',
      variableLabel: 'Variabele',
      variableHint: 'Naam van de variabele om weer te geven.',
      variableDetecting: 'Variabelen detecteren…',
      variableManualHint: 'Automatische detectie mislukt. Voer de naam handmatig in.',
      dimensionDetecting: 'Dimensies detecteren…',
      dimensionAutoHint: 'Automatisch gedetecteerd uit dataset. Pas waarden aan indien nodig.',
      dimensionFillError: 'Dimensies detectie mislukt. Gebruik het formulier hieronder.',
      dimensionSelectorLabel: 'Dimensiekiezer',
      dimensionKeyLabel: 'Dimensie',
      dimensionValueLabel: 'Waarde',
      addDimension: 'Dimensie toevoegen',
      styleLabel: 'Stijl',
      opacityLabel: 'Dekking',
      rescaleLabel: 'Herschalen (min,max)',
      rescalePlaceholder: 'bijv. 0,1000',
      rescaleHint: "Optioneel min,max-bereik gescheiden door komma's voor weergaveschaling.",
      colorMapLabel: 'Kleurenschema',
      colorMapHint: 'Optioneel rio-tiler kleurenschema. Leeg laten om RGB-banden te gebruiken.'
    },
    multidimUpload: {
      fileLabel: 'NetCDF-bestand(en) kiezen',
      fileHint:
        'Ondersteunde formaten: <code>.nc</code>, <code>.nc4</code>. Je kunt meerdere bestanden selecteren — ze delen dezelfde configuratie.',
      sourceFormatLabel: 'Bronformaat',
      variableLabel: 'Variabele',
      variableHint: 'Naam van de variabele om weer te geven.',
      dimensionSelectorLabel: 'Dimensiekiezer',
      dimensionKeyLabel: 'Dimensie',
      dimensionValueLabel: 'Waarde',
      addDimension: 'Dimensie toevoegen',
      styleLabel: 'Stijl',
      opacityLabel: 'Dekking',
      rescaleLabel: 'Herschalen (min,max)',
      rescalePlaceholder: 'bijv. 0,1000',
      rescaleHint: "Optioneel min,max-bereik gescheiden door komma's voor weergaveschaling.",
      colorMapLabel: 'Kleurenschema',
      colorMapHint: 'Optioneel rio-tiler kleurenschema. Leeg laten om standaard te gebruiken.'
    },
    oneLakeFile: {
      styleLabel: 'Stijl',
      opacityLabel: 'Dekking',
      rescaleLabel: 'Herschalen (min,max)',
      rescalePlaceholder: 'bijv. 0,1000',
      rescaleHint: "Optioneel min,max-bereik gescheiden door komma's voor weergaveschaling.",
      colorMapLabel: 'Kleurenschema',
      colorMapHint: 'Optioneel rio-tiler kleurenschema. Leeg laten om RGB-banden te gebruiken.',
      hazardPaletteLabel: 'Nexus-gevaarpalet',
      hazardPaletteHint:
        'Past de kleuren van de blootstellingsmeter toe voor een Nexus-gevaar. Ontworpen voor een percentiel van 0–100 met een 0,100-herschaling.',
      hazardPalettes: {
        wind: 'Wind',
        wildfire: 'Bosbrand',
        heat: 'Hitte',
        cold: 'Koude',
        precipitation: 'Neerslag',
        flooding: 'Overstroming',
        hail: 'Hagel',
        drought: 'Droogte',
        'global-risk': 'Globaal risicopercentiel'
      }
    },
    controls: {
      buildings3dShow: '3D-gebouwen weergeven',
      buildings3dHide: '3D-gebouwen verbergen',
      trafficShow: 'Verkeer weergeven',
      trafficHide: 'Verkeer verbergen',
      weatherShow: 'Weerlaag weergeven',
      weatherActive: '{type} weerlaag actief (klik om te verbergen)',
      weatherNone: 'Geen',
      weatherRadar: 'Radar',
      weatherInfrared: 'Infrarood',
      demShow: 'Terreinverhoging weergeven (DEM)',
      demHide: 'Terreinverhoging verbergen (DEM)'
    },
    detailsPanel: {
      title: 'Details',
      empty: 'Selecteer een object op de kaart om de details te bekijken.'
    },
    legend: {
      title: 'Legenda',
      noData: 'Geen gegevens',
      minimize: 'Legenda minimaliseren',
      expand: 'Legenda uitklappen',
      loading: 'Legenda laden…',
      loadError: 'Legenda niet beschikbaar',
      filterHide: 'Deze klasse van de kaart filteren',
      filterShow: 'Deze klasse op de kaart tonen',
      filterReset: 'Alle klassen tonen'
    },
    graph: {
      empty:
        'Geen twins om te tonen. Blader of selecteer een twin om de relatiegrafiek te bekijken.',
      layout: 'Indeling',
      layouts: {
        klay: 'Hiërarchisch',
        breadthfirst: 'Breedte-eerst',
        circle: 'Cirkel',
        concentric: 'Concentrisch',
        cose: 'Krachtgestuurd',
        grid: 'Raster'
      },
      fetchIncoming: 'Inkomende {relationship} ophalen',
      fetchOutgoing: 'Uitgaande {relationship} ophalen',
      fetchIncomingAll: 'Inkomende relaties ophalen',
      fetchOutgoingAll: 'Uitgaande relaties ophalen'
    },
    viewerDataPanel: {
      title: 'Lagen',
      filterPlaceholder: 'Lagen filteren',
      findLayerPlaceholder: 'Laag zoeken',
      source: 'Bron: {source}',
      opacity: 'Dekking: {pct} %',
      ungrouped: 'Niet gegroepeerd',
      show: 'Weergeven',
      hide: 'Verbergen',
      map: 'Kaart',
      threeD: '3D',
      graph: 'Grafiek',
      mapLayers: 'Kaartlagen',
      groupCount: '{loaded} van {total} lagen geladen',
      twinsLayer: 'Tegelgegevens',
      menu: {
        trigger: 'Laag beheren'
      },
      samePanelLayout: {
        label: 'Indeling van panelen aan dezelfde zijde',
        tabs: 'Tabbladen (gecombineerd)',
        split: 'Gesplitst (afzonderlijke panelen)',
        description:
          'Hoe de lagen- en legendapanelen worden gerangschikt wanneer ze aan dezelfde zijde staan.'
      }
    },
    alignment: {
      menuItem: 'Modeluitlijning aanpassen',
      title: 'Model uitlijnen',
      description:
        'Verschuif en schaal het model zodat het aansluit op de andere lagen. De uitlijning wordt op het model opgeslagen en bij elke lading toegepast.',
      positionHeading: 'Positie',
      rotationHeading: 'Rotatie',
      offsetX: 'Verschuiving X',
      offsetY: 'Verschuiving Y',
      offsetZ: 'Verschuiving Z',
      rotationX: 'Rotatie X',
      rotationY: 'Rotatie Y',
      rotationZ: 'Rotatie Z',
      metres: 'm',
      degrees: '°',
      factor: '×',
      scale: 'Schaal',
      scaleHint: '1 behoudt de oorspronkelijke grootte, 2 verdubbelt deze, 0,5 halveert deze',
      invalidScale: 'Schaal moet groter zijn dan 0'
    },
    geoTiffStyling: {
      menuItem: 'Laagstijl aanpassen',
      title: 'Laagstijl',
      rasterHeading: 'Rasterinstellingen',
      rasterHint: 'Stel het bronzoombereik en de tegelgrootte in.',
      tileMinSourceZoomLabel: 'Minimale bronzoom',
      tileMaxSourceZoomLabel: 'Maximale bronzoom',
      tileScaleLabel: 'Tegelschaal',
      tileScaleHint: '1 gebruikt tegels van 256 x 256 pixels.',
      suggestRescale: 'Stel herschalen voor op basis van p2-p98-statistieken',
      statisticsUnavailable: 'Statistieken zijn niet beschikbaar voor deze laag.',
      statisticsError: 'Kan geen herschaalbereik voorstellen.'
    }
  },
  formTile: {
    keyValueArray: {
      keyLabel: 'Sleutel',
      value: 'Waarde',
      add: 'Toevoegen',
      edit: 'Bewerken',
      remove: 'Verwijderen',
      confirm: 'Bevestigen',
      cancel: 'Annuleren',
      empty: 'Nog geen items.',
      duplicateKey: 'Deze sleutel bestaat al.'
    }
  },
  dashboard: {
    toolbar: {
      new: 'Nieuw',
      more: 'Meer',
      newParameter: 'Nieuwe parameter',
      newTile: 'Nieuwe tegel',
      configuration: 'Configuratie',
      savePictures: 'Afbeeldingen opslaan',
      saveLayout: 'Lay-out opslaan',
      sharedQueries: "Gedeelde query's",
      print: 'Afdrukken',
      slider: 'Schuifregelaar',
      rangeSlider: 'Bereikschuifregelaar',
      openEditor: 'Dashboard-editor'
    }
  },
  gaugeTile: {
    minimum: 'Min: {value}',
    maximum: 'Max: {value}'
  },
  treeTable: {
    name: 'Naam',
    actions: 'Acties',
    columns: 'Kolommen',
    collapse: 'Inklappen',
    collapseAll: 'Alles inklappen',
    expand: 'Uitklappen',
    expandAll: 'Alles uitklappen',
    filter: 'Filter',
    goTo: 'Openen',
    groupBy: 'Groeperen op',
    noData: 'Geen rijen komen overeen met de toegepaste filters.',
    truncated:
      'Meer rijen dan getoond kunnen worden — {count} verborgen. Klap een tak in of groepeer op een hoger niveau.'
  },
  treeTableFeature: {
    title: 'Boomtabel',
    mode: 'Weergavemodus',
    browse: 'Bladeren',
    customQuery: 'Query',
    queryKind: 'Querytype',
    execute: 'Uitvoeren',
    open: 'Openen'
  },
  lazyExtension: {
    loadFailed: 'Een deel van deze pagina kon niet worden geladen. Probeer opnieuw.'
  },
  optionPicker: {
    select: 'Selecteren…',
    loading: 'Laden…',
    empty: 'Geen opties beschikbaar',
    error: 'Opties konden niet worden geladen',
    clear: 'Wissen',
    confirmTitle: 'Bevestig alstublieft',
    confirmDefault: 'Wilt u doorgaan?',
    confirm: 'Bevestigen',
    cancel: 'Annuleren',
    failed: 'De actie is mislukt'
  },
  jetconnect: {
    assignPlaceholder: 'POC toewijzen…',
    floor: 'Verdieping {floor}',
    capacityLeft: '{amount} {unit} over na toewijzing',
    capacityShort: 'Tekort van {amount} {unit}',
    distanceMetres: '{distance} m',
    distanceViewerUnits: '{distance} viewer-eenheden',
    distanceUnknown: 'Afstand onbekend',
    notInViewer: 'Niet in het 3D-model: handmatig toewijzen',
    insufficientCapacity: 'Onvoldoende capaciteit',
    viewerLoading: 'Viewer laadt…',
    pocsLoading: "POC's laden…",
    pocsError: "POC's konden niet worden geladen",
    rankError: "POC's konden niet worden gerangschikt",
    noCandidates: 'Geen compatibele POC voor {serviceCode}',
    noCandidatesInRange: 'Geen compatibele POC binnen {max} m',
    filterUncalibrated:
      'Afstandsfilter niet toegepast: de viewerafstand is niet gekalibreerd naar meters',
    writeFailed: 'Toewijzing mislukt: {reason}',
    noConnection: 'Deze rij is geen aansluiting',
    assigned: 'Toegewezen aan {poc}',
    unassigned: 'Toewijzing verwijderd',
    confirmOverCapacity:
      '{poc} heeft niet genoeg capaciteit meer voor deze aansluiting. Toch toewijzen? De resterende capaciteit wordt negatief.',
    autoAssign: {
      blocked: 'Nog niet beschikbaar: {reason}',
      button: 'Automatisch toewijzen',
      buttonBlocked: 'Automatisch toewijzen ({reason})',
      noTool: 'selecteer een tool',
      dataLoading: 'gegevens laden…',
      loadError: 'gegevens konden niet worden geladen',
      unavailable: 'Automatisch toewijzen is hier niet beschikbaar',
      title: 'Aansluitingen automatisch toewijzen',
      scopeTool: 'Hele tool · niet-toegewezen aansluitingen: {count}',
      scopeSelection: 'Selectie · niet-toegewezen aansluitingen: {count}',
      onlySelected: 'Alleen de geselecteerde aansluitingen ({count})',
      summary:
        '{assigned} toe te wijzen · {unassignable} niet toewijsbaar · {skipped} al toegewezen (overgeslagen)',
      plannedTitle: 'Geplande toewijzingen',
      unassignableTitle: 'Niet toewijsbaar',
      nothing:
        'Niets toe te wijzen: elke aansluiting in de scope is al toegewezen of kan niet worden geplaatst.',
      colConnection: 'Aansluiting',
      colSystem: 'Systeem',
      colRequired: 'Vereist',
      colCapacity: 'Resterende capaciteit',
      colReason: 'Reden',
      pocCapacity: '{before} → {after} {unit}',
      pocUsed: 'Aansluitingen: {count} · {used} {unit}',
      distanceUnknownNote:
        '{count} geplande toewijzingen gebruiken een POC met onbekende afstand; ze staan onderaan.',
      confirm: '{count} toewijzen',
      cancel: 'Annuleren',
      close: 'Sluiten',
      undo: 'Ongedaan maken',
      undoCount: '{count} ongedaan maken',
      progress: 'Toewijzen… {done} / {total}',
      undoProgress: 'Ongedaan maken… {done} / {total}',
      resultAssigned: 'Aansluitingen toegewezen: {count}',
      resultFailed: '{count} mislukt',
      resultAlready: '{count} waren intussen toegewezen en zijn ongewijzigd gelaten',
      tableRefresh: 'De tabel wordt over enkele seconden bijgewerkt.',
      undone: 'Toewijzingen ongedaan gemaakt: {count}',
      undoStateChanged: '{count} ongewijzigd gelaten omdat ze sinds de run zijn aangepast',
      undoFailed: '{count} konden niet ongedaan worden gemaakt',
      failed: 'Automatisch toewijzen mislukt: {message}',
      reason: {
        'no-capacity': 'Geen POC van dit systeem heeft nog genoeg capaciteit',
        'no-matching-system': 'Er bestaat geen POC voor dit systeem',
        'unit-mismatch': 'Geen POC van dit systeem gebruikt dezelfde eenheid',
        'distance-unavailable': 'Alleen POC’s met onbekende afstand hebben capaciteit',
        'invalid-requirement': 'Vereist debiet ontbreekt of is geen getal'
      }
    }
  },
  table: {
    toolbar: {
      links: 'Links',
      import: 'Importeren',
      more: 'Meer',
      editQueries: "Query's bewerken",
      newQuery: 'Nieuw',
      createNewFeatureQuery: 'Nieuwe functiequery aanmaken',
      saveFeatureQueries: "Functiequery's opslaan",
      queryAll: 'Alles opvragen',
      queryAllWithFilters: 'Alles opvragen met filters',
      newFolder: 'Nieuwe map',
      new: 'Nieuw',
      createNewTwin: 'Nieuwe tweeling aanmaken',
      addMultipleTwins: 'Meerdere tweelingen toevoegen',
      editTwin: 'Geselecteerde tweeling bewerken',
      editTwins: 'Geselecteerde tweelingen bewerken',
      move: 'Verplaatsen',
      moveTwin: 'Geselecteerde tweeling verplaatsen',
      moveTwins: 'Geselecteerde tweelingen verplaatsen',
      duplicate: 'Dupliceren',
      duplicateTwin: 'Geselecteerde tweeling dupliceren',
      deleteTwin: 'Geselecteerde tweeling verwijderen',
      deleteTwins: 'Geselecteerde tweelingen verwijderen',
      clear: 'Wissen',
      clearSelection: 'Selectie wissen',
      addMarker: 'Markering toevoegen',
      addMarkerTooltip: 'Markering toevoegen in de viewer',
      removeMarker: 'Markering verwijderen',
      removeMarkerTooltip: 'Markering van geselecteerde tweeling verwijderen in de viewer',
      linkTwinToObject: 'Tweeling koppelen aan object',
      linkTwinToObjectTooltip: 'Geselecteerde tweeling koppelen aan object in de viewer',
      removeLink: 'Koppeling verwijderen',
      removeLinkTooltip: 'Koppeling tussen geselecteerde tweeling en viewer verwijderen',
      linkTwinsByProperty: 'Tweelingen koppelen op eigenschap',
      linkTwinsByPropertyTooltip: 'Tweelingen koppelen aan objecten in de viewer op eigenschap',
      removeLinksByProperty: 'Koppelingen verwijderen op eigenschap',
      removeLinksByPropertyTooltip: 'Gekoppelde tweelingen verwijderen in de viewer op eigenschap',
      updateTwinsByProperty: 'Tweelingen bijwerken op eigenschap',
      updateTwinsByPropertyTooltip:
        'Bestaande gekoppelde tweelingen bijwerken met gegevens uit de viewer',
      importFromFile: 'Importeren vanuit bestand',
      importFromFileTooltip:
        'Tweelinggegevens importeren vanuit een bestand (CSV, Excel, JSON, ...)',
      uploadFilesFromFolder: 'Bestanden uploaden vanuit map',
      importSelectedObjectsOld: 'Geselecteerde objecten importeren uit viewer (oud)',
      importAllObjectsOld: 'Alle objecten importeren uit viewer (oud)',
      importSelectedObjects: 'Geselecteerde objecten importeren uit viewer',
      importAllObjects: 'Alle objecten importeren uit viewer',
      export: 'Exporteren',
      restoreViewerState: 'Viewerstatus herstellen',
      saveViewerState: 'Viewerstatus opslaan',
      uploadFiles: 'Bestanden uploaden',
      linkAutodeskFile: 'Autodesk-bestand koppelen',
      generateQRCode: 'QR-code genereren',
      generateQRCodesBulk: 'QR-codes genereren (bulk)'
    }
  },
  chat: {
    header: {
      toggle: 'AI Chat inschakelen'
    },
    drawer: {
      title: 'AI-assistent',
      clearChat: 'Nieuwe sessie',
      tryAsking: 'Probeer te vragen:',
      aiAssistantName: 'AI-assistent',
      errorOccurred: 'Er is een fout opgetreden. Probeer het opnieuw.',
      retry: 'Opnieuw proberen',
      typeMessage: 'Typ een bericht...',
      sendMessage: 'Bericht versturen',
      stopGenerating: 'Genereren stoppen',
      disclaimer: 'AI kan fouten maken. Controleer belangrijke informatie.',
      you: 'U',
      welcomeTitle: 'Digitale Tweelingen Assistent',
      climateRiskTitle: 'Klimaatrisico Assistent',
      welcomeSubtitle:
        'Ik kan u helpen uw digitale tweelingengegevens te verkennen en te begrijpen',
      climateRiskSubtitle: 'Ik kan u helpen klimaatgevaren en risicoscores te begrijpen',
      envSuffix: ' in ',
      defaultSuggestion1: 'Hoe kunt u me helpen?',
      defaultSuggestion2: 'Hoe doe ik een query op digitale tweelingen?',
      defaultSuggestion3: 'Toon me de beschikbare gegevens',
      climateRiskSuggestion1: 'Hoe wordt de hittescore berekend?',
      climateRiskSuggestion2: 'Hoe worden scores vergeleken?',
      climateRiskSuggestion3: 'Welke gevaarmetrieken worden gebruikt voor kustoverstromingen?',
      modelLabel: 'Model',
      continueWithModel: 'Doorgaan met een ander model'
    },
    toolCall: {
      executing: 'Bezig...',
      error: 'Fout',
      completed: 'Voltooid',
      awaitingApproval: 'Wacht op goedkeuring',
      rejected: 'Afgewezen',
      approvalReason: 'Optionele reden voor afwijzing',
      approve: 'Goedkeuren',
      reject: 'Afwijzen',
      input: 'Invoer',
      output: 'Uitvoer'
    },
    flowPreview: {
      title: 'Wijzigingen toegepast',
      activitiesChanged: '{count} activiteit gewijzigd | {count} activiteiten gewijzigd',
      keep: 'Behouden',
      undo: 'Ongedaan maken'
    },
    tilePreview: {
      title: 'Tegelvoorbeeld',
      unsupported: 'Voorbeeld niet beschikbaar voor {type}.',
      addToDashboard: 'Toevoegen aan dashboard',
      addedToDashboard: 'Tegel "{name}" toegevoegd aan dashboard.',
      addFailed: 'Kon tegel niet toevoegen aan dashboard.',
      noDashboard: 'Er is geen dashboard actief.',
      openEditor: 'Editor openen'
    },
    dashboardPreview: {
      title: 'Wijzigingen toegepast',
      tilesChanged: '{count} tegel gewijzigd | {count} tegels gewijzigd',
      keep: 'Behouden',
      undo: 'Ongedaan maken'
    },
    sessions: {
      title: 'Gespreksgeschiedenis',
      history: 'Gespreksgeschiedenis',
      empty: 'Geen eerdere gesprekken',
      untitled: 'Naamloos gesprek',
      messageCount: '{count} bericht | {count} berichten',
      loadError: 'Laden van gesprek mislukt',
      deleteError: 'Verwijderen van gesprek mislukt'
    },
    attachments: {
      attachFiles: 'Bestanden bijvoegen',
      dropFiles: 'Zet bestanden neer om ze toe te voegen',
      removeAttachment: 'Bijlage verwijderen'
    }
  },
  runtimeParameters: {
    malformedMultiValue: 'Parameter "{name}" bevat een ongeldige selectie met meerdere waarden.'
  },
  featureEditor: {
    title: 'Functie-editor',
    preview: 'Voorbeeld',
    save: 'Wijzigingen opslaan',
    discard: 'Negeren',
    back: 'Terug naar functie',
    backToParent: 'Terug naar bovenliggende functie',
    unsavedChanges: 'Niet-opgeslagen wijzigingen',
    saved: '{count} wijziging opgeslagen | {count} wijzigingen opgeslagen',
    saveFailed: '{count} wijziging niet opgeslagen | {count} wijzigingen niet opgeslagen',
    retry: 'Opnieuw proberen',
    sharedWarning:
      'Deze functie wordt door {count} andere functie hergebruikt | Deze functie wordt door {count} andere functies hergebruikt. Wijzigingen gelden voor alle.',
    upstreamChanged:
      'Deze functie is elders gewijzigd terwijl u aan het bewerken was. Nu opslaan kan die wijzigingen overschrijven.',
    reloadFromServer: 'Opnieuw laden van server',
    editingDashboard: 'Functie die wordt bewerkt',
    noCopyTargets: 'Geen andere dashboards',
    previewHint:
      'Toont het dashboard alleen-lezen, precies zoals gebruikers het zien: tegels kunnen niet worden verplaatst of van grootte worden veranderd, tegels die verborgen zijn door hun verbergexpressie blijven verborgen en formaat-naar-inhoud / zwevend blijven actief. Uit onthult alle tegels zodat de indeling volledig bewerkbaar blijft.',
    parameters: {
      title: 'Parameters',
      add: 'Parameter toevoegen',
      empty: 'Geen parameters',
      label: 'Label',
      name: 'Variabelenaam',
      kind: 'Type',
      displayStyle: 'Weergavestijl',
      defaultValue: 'Standaardwaarde',
      remove: 'Parameter verwijderen',
      configuration: 'Configuratie',
      currentValue: 'Huidige waarde',
      listView: 'Parameterlijst',
      contextView: 'Expressiecontext',
      currentValueHint: 'Opgeloste runtimewaarde. Deze weergave is alleen-lezen.',
      noCurrentValue: 'Er is geen huidige waarde opgelost voor deze parameter.',
      copyCurrentValue: 'Huidige waarde kopiëren',
      currentValueCopied: 'Huidige parameterwaarde gekopieerd naar het klembord'
    },
    queries: {
      title: 'Gedeelde query’s',
      add: 'Gedeelde query toevoegen',
      empty: 'Geen gedeelde query’s',
      addQuery: 'Query toevoegen',
      emptyQueries: 'Geen query’s'
    },
    deleteTileConfirm:
      'Tegel "{name}" verwijderen uit het concept? Deze wordt verwijderd bij het opslaan.',
    tile: {
      unnamed: 'Naamloze tegel',
      name: 'Tegelnaam',
      appearance: 'Weergave',
      backgroundColor: 'Achtergrondkleur',
      flat: 'Plat',
      bordered: 'Omrand',
      square: 'Vierkant',
      headerFontSize: 'Lettergrootte kop',
      headerAlign: 'Uitlijning kop',
      cssClass: 'CSS-klasse',
      layout: 'Indeling',
      x: 'X',
      y: 'Y',
      width: 'Breedte',
      height: 'Hoogte',
      advancedEdit: 'Bewerken in dialoogvenster',
      configureHint: 'Configureer deze tegel in het rechterpaneel',
      nestedDashboards: 'Geneste dashboards',
      editNestedDashboard: 'Dit geneste dashboard bewerken',
      duplicated: 'Tegel gedupliceerd'
    },
    tabs: {
      tile: 'Tegel',
      dashboard: 'Functie',
      parameters: 'Parameters',
      queries: 'Query’s',
      children: 'Childfuncties',
      copilot: 'Copiloot'
    },
    children: {
      empty:
        'Geen childfuncties. Voeg functies toe met deze functie als bovenliggende functie, of configureer tabbladen expliciet.'
    },
    copilot: {
      welcomeTitle: 'Functie-copiloot',
      welcomeSubtitle:
        'Vraag me tegels toe te voegen, query’s te wijzigen of dit dashboard te restylen.',
      welcomeSubtitleTabs:
        'Vraag me de tabbladen, de header of de parameters van deze functie te wijzigen.'
    },
    addTile: 'Tegel toevoegen',
    tileCatalog: {
      filter: 'Filter tegeltypen',
      noResults: 'Geen tegels gevonden die aan uw zoekopdracht voldoen'
    }
  },
  fabricTree: {
    lakehouse: 'Lakehouse',
    folder: 'Map',
    file: 'Bestand',
    noItems: 'Geen items beschikbaar'
  },
  twinMoveDialog: {
    title: 'Verplaats {count} tweeling | Verplaats {count} tweelingen',
    subtitle: 'Beheer ouder-kind relaties',
    removeRels: 'Verwijder inkomende relaties',
    optional: 'optioneel',
    addRels: 'Nieuwe relaties toevoegen',
    newParent: 'Nieuwe ouder tweeling(en)',
    relType: 'Relatietype',
    relTypeAll: 'Alle relaties worden aangemaakt als {name}',
    onlyOption: 'enige optie',
    move: 'Verplaatsen',
    relIdGen: 'Relatie-ID',
    relIdGenUid: 'Automatisch gegenereerd (UUID)',
    relIdGenSourceTarget: 'Bron-Doel patroon'
  },
  profile: {
    title: 'Mijn profiel',
    description: 'Beheer je contactgegevens en hoe het platform je op de hoogte brengt.',
    contactDetails: 'Contactgegevens',
    email: 'E-mail',
    phoneNumber: 'Mobiel telefoonnummer',
    phoneNumberHint: 'Internationaal formaat, inclusief landcode (bijvoorbeeld +32470000000)',
    phoneNumberInvalid:
      'Geef je nummer in internationaal formaat, inclusief landcode (bijvoorbeeld +32470000000)',
    smsTitle: 'Sms-meldingen',
    smsOptionalBadge: 'Optioneel',
    smsIntro:
      'Flows in het platform kunnen je een sms sturen wanneer er iets je aandacht vraagt. Dit is volledig optioneel: je kan het Arcadis Digital Twins-platform ook zonder gebruiken, en het maakt geen deel uit van de algemene voorwaarden die je hebt aanvaard.',
    smsConsentLabel:
      'Ja, ik stem ermee in om sms-meldingen van Arcadis Digital Twins te ontvangen op het telefoonnummer hierboven.',
    smsPhoneRequired: 'Voeg eerst je mobiele telefoonnummer toe om toestemming te kunnen geven.',
    smsFrequency:
      'Berichtfrequentie: occasionele waarschuwingen en meldingen die worden geactiveerd door de flows van jouw omgeving. We versturen geen terugkerende marketingberichten.',
    smsRates: 'Bericht- en datakosten kunnen van toepassing zijn.',
    smsOptOut: 'Antwoord STOP om op elk moment te stoppen. Antwoord HELP voor hulp.',
    smsLinks: 'Hoe we je gegevens verwerken:',
    privacyPolicy: 'Privacybeleid',
    termsAndConditions: 'Algemene voorwaarden',
    smsOptedInSince: 'Je hebt op {date} toestemming gegeven.',
    smsNotOptedIn: 'Je ontvangt geen sms-meldingen.',
    saved: 'Je voorkeuren zijn opgeslagen.',
    saveFailed: 'Je voorkeuren konden niet worden opgeslagen. Probeer het opnieuw.',
    loadFailed: 'Je profiel kon niet worden geladen. Probeer het opnieuw.'
  },
  twinEditProperty: {
    smsRecipients: {
      label: 'Ontvangers',
      hint: 'Alleen gebruikers met een telefoonnummer die toestemming gaven voor sms-meldingen worden weergegeven',
      noRecipients:
        'Nog geen gebruiker in deze omgeving heeft toestemming gegeven voor sms-meldingen',
      unknownRecipient: 'Onbekende ontvanger',
      expressionInUse: 'Deze activiteit gebruikt een expressie om de ontvangers te bepalen.',
      useRecipientList: 'In plaats daarvan gebruikers selecteren'
    },
    secretFields: {
      sas: 'SAS',
      username: 'Gebruikersnaam',
      // eslint-disable-next-line sonarjs/no-hardcoded-passwords
      password: 'Wachtwoord', // NOSONAR - This is a label, not a real password field
      clientId: 'Client-ID',
      clientSecret: 'Clientgeheim',
      apiKey: 'API-sleutel',
      sharedKeyName: 'Naam van gedeelde sleutel',
      sharedKey: 'Gedeelde sleutel',
      token: 'Token',
      refreshToken: 'Vernieuwingstoken',
      authBody: 'Authenticatieverzoekbody',
      authHeaders: 'Authenticatieverzoekheaders (JSON)'
    }
  }
}
